export const SUBSCRIPTION_EXPLORER_MARKUP = 'subscription.explorer.markup';
export const BILLING_ANALYZER_SUBSCRIPTION_CHANGE =
  'billing.analyzer_subscription_change';

export const USER_ADMIN = 'user.admin';
export const API_DASHBOARD = 'api.dashboard';
export const SUBSCRIPTION_EXPLORER_MENTIONS = 'subscription.explorer.mentions';
